var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 186,
    viewBox: "0 0 319 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109.286,
    height: 109.286,
    rx: 54.6429,
    transform: "matrix(0.978148 -0.207912 0.201161 0.979558 79.6436 48)",
    fill: "#57B4EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_369_10938)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.644,
    y: 48,
    width: 115.714,
    height: 115.714,
    rx: 57.8571,
    fill: "#C7E7FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.965,
    y: 48.3214,
    width: 115.071,
    height: 115.071,
    rx: 57.5357,
    stroke: "white",
    strokeWidth: 0.642857
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.431 138C177.598 138 173.346 137.175 169.675 135.525C166.003 133.831 163.145 131.913 161.101 129.773C159.102 127.588 158.103 125.76 158.103 124.288C158.103 123.486 158.429 122.928 159.079 122.616C159.73 122.304 160.427 122.304 161.17 122.616C163.726 123.954 166.631 125.247 169.884 126.495C173.183 127.699 177.366 128.301 182.431 128.301C187.497 128.301 191.656 127.699 194.909 126.495C198.208 125.247 201.113 123.954 203.622 122.616C204.366 122.304 205.063 122.304 205.713 122.616C206.41 122.928 206.759 123.486 206.759 124.288C206.759 125.76 205.737 127.588 203.692 129.773C201.694 131.913 198.859 133.831 195.188 135.525C191.516 137.175 187.264 138 182.431 138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.728 98.5367C159.544 98.5367 157.639 97.6895 156.012 95.995C154.386 94.256 153.572 92.0487 153.572 89.3732C153.572 86.6978 154.386 84.4905 156.012 82.7514C157.639 81.0124 159.544 80.1429 161.728 80.1429C163.959 80.1429 165.91 81.0124 167.583 82.7514C169.256 84.4905 170.093 86.6978 170.093 89.3732C170.093 92.0487 169.256 94.256 167.583 95.995C165.91 97.6895 163.959 98.5367 161.728 98.5367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.065 98.5367C200.88 98.5367 198.975 97.6895 197.349 95.995C195.722 94.256 194.909 92.0487 194.909 89.3732C194.909 86.6978 195.722 84.4905 197.349 82.7514C198.975 81.0124 200.88 80.1429 203.065 80.1429C205.295 80.1429 207.247 81.0124 208.92 82.7514C210.593 84.4905 211.429 86.6978 211.429 89.3732C211.429 92.0487 210.593 94.256 208.92 95.995C207.247 97.6895 205.295 98.5367 203.065 98.5367Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6883 144.857L56.292 147.46L61.0328 142.719L58.4291 140.116L53.6883 144.857Z",
    fill: "#58B5EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.758 182.831L107.361 185.435L112.102 180.694L109.498 178.091L104.758 182.831Z",
    fill: "#2DBCAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.208 31.5645L300.812 34.1682L305.552 29.4274L302.949 26.8238L298.208 31.5645Z",
    fill: "#58B5EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74105 135.789L7.34473 133.185L2.60397 128.444L0.000288949 131.048L4.74105 135.789Z",
    fill: "#D1E4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.259 147.972L311.655 150.575L316.396 155.316L319 152.712L314.259 147.972Z",
    fill: "#58B5EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.452 164.994L227.849 167.598L232.589 172.339L235.193 169.735L230.452 164.994Z",
    fill: "#58B5EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8752 83.4454L8.27148 86.049L13.0122 90.7898L15.6159 88.1861L10.8752 83.4454Z",
    fill: "#58B5EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8839 72.8859L49.2803 75.4896L54.021 80.2303L56.6247 77.6267L51.8839 72.8859Z",
    fill: "#D1E4FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.717 87.0651L258.113 84.4614L253.373 89.2022L255.976 91.8059L260.717 87.0651Z",
    fill: "#2DBCAA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7951 32.2518L12.1914 29.6481L7.45065 34.3889L10.0543 36.9926L14.7951 32.2518Z",
    fill: "#2DBCAA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.245 2.60366L101.642 0L96.9008 4.74076L99.5045 7.34442L104.245 2.60366Z",
    fill: "#2DBCAA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.97 80.5806L310.291 80.7485L310.597 87.4463L314.275 87.2784L313.97 80.5806Z",
    fill: "#D1E4FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.135 8.46029L213.904 11.6896L219.784 8.46871L218.015 5.23944L212.135 8.46029Z",
    fill: "#D1E4FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_369_10938",
    x: 76.4293,
    y: -0.214283,
    width: 212.142,
    height: 212.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.1071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_369_10938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_369_10938",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.42857,
    dy: 6.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.64286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_369_10938"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.7222877b114568df817a714288f044e2.svg";
export { ForwardRef as ReactComponent };